import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import AcquisitionBanner from './components/AcquisitionBanner';
import AftermathBanner from './components/AftermathBanner';
import './App.css';

function App() {
  return (
    <CartProvider>
      <Router>
        <div className="App">
          <AftermathBanner />
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
            </Routes>
          </main>
          <Footer />
          <AcquisitionBanner />
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;
